import "core-js/fn/object/assign";
import "core-js/fn/array/find";
import "core-js/fn/array/find-index";
import "core-js/fn/array/fill";
import "core-js/fn/array/includes";
import "core-js/fn/array/from";
import "core-js/fn/promise";
//import "core-js/fn/string/index.js";
